export default __webpack_public_path__ + "newlogo_inv_sm.png";